module.exports = __webpack_public_path__ + "static/media/close.7e19f165.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/close.svg
// module id = 1251
// module chunks = 0